import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { forwardRef } from "react";

import { cn } from "@/lib/utils";

const RadioChecked = () => (
  <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-[1.5px] border-[#091E42]">
    <span className="block h-2.5 w-2.5 rounded-full bg-[#091E42]" />
  </span>
);

const RadioUnchecked = () => (
  <span className="flex h-5 w-5 shrink-0 rounded-full border-[1.5px] border-[#091E42]" />
);

const DropdownMenuRadioItemNoIndicator = forwardRef<
  React.ElementRef<typeof DropdownMenuPrimitive.CheckboxItem>,
  React.ComponentPropsWithoutRef<typeof DropdownMenuPrimitive.CheckboxItem>
>(({ className, children, checked = false, ...props }, ref) => (
  <DropdownMenuPrimitive.CheckboxItem
    ref={ref}
    className={cn(
      "relative flex cursor-default select-none items-center gap-[10px] rounded-sm py-1.5 pr-5 pl-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      className
    )}
    checked={checked}
    {...props}
  >
    {checked ? <RadioChecked /> : <RadioUnchecked />}
    {children}
  </DropdownMenuPrimitive.CheckboxItem>
));

DropdownMenuRadioItemNoIndicator.displayName =
  "DropdownMenuRadioItemNoIndicator";

export default DropdownMenuRadioItemNoIndicator;
